import assetPath from '/opt/actions-runner/_work/crate/crate/packages/entity-pages/entity-pages-jobs/src/assets/bookmark-fill.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')